import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as contentblockActions from '../actions/content-pages.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ContentPagesService } from '../../services';
import { Go } from 'src/app/store';

@Injectable()
export class ContentPagesEffects {
  private actions$ = inject(Actions);
  private PageService = inject(ContentPagesService);

  LoadBugs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadContentPages),
      switchMap(() =>
        this.PageService.getPages().pipe(
          map(contentPages => {
            if (!contentPages) {
              return contentblockActions.LoadContentPagesFail({ error: { status: 404 } });
            }
            return contentblockActions.LoadContentPagesSuccess({ contentPages });
          }),
          catchError(error => of(contentblockActions.LoadContentPagesFail({ error })))
        )
      )
    );
  });

  LoadBySlug$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadContentPageBySlug),
      switchMap(({ slug }) =>
        this.PageService.getPageBySlug(slug).pipe(
          map(page => {
            if (!page) {
              return contentblockActions.LoadContentPageBySlugFail({ slug, error: { status: 404 } });
            }
            return contentblockActions.LoadContentPageBySlugSuccess({ page, slug });
          }),
          catchError(error => of(contentblockActions.LoadContentPageBySlugFail({ slug, error })))
        )
      )
    );
  });

  LoadBySlugFail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadContentPageBySlugFail),
      map(({ error }) => {
        return Go({ path: ['/404'], extras: { skipLocationChange: true } });
      })
    );
  });

  LoadById$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadContentPageById),
      switchMap(({ id }) =>
        this.PageService.getPageById(id).pipe(
          map(page => {
            if (!page) {
              return contentblockActions.LoadContentPageByIdFail({ id, error: { status: 404 } });
            }
            return contentblockActions.LoadContentPageByIdSuccess({ page });
          }),
          catchError(error => of(contentblockActions.LoadContentPageByIdFail({ id, error })))
        )
      )
    );
  });

  LoadByIdFail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(contentblockActions.LoadContentPageByIdFail),
      map(({ error }) => {
        return Go({ path: ['/404'], extras: { skipLocationChange: true } });
      })
    );
  });
}
